import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMailingAddress } from "@utils/interfaces";

export interface MyInfoProps {
  salutation?: string | undefined | null;
  firstName?: string | undefined | null;
  lastName?: string | undefined | null;
  fullName: string | undefined | null;
  mobileNum?: string | undefined | null;
  emailId?: string | undefined | null;
  nric: string;
  dateOfBirth: string;
  nationality: string;
  residentialStatus: string;
  gender: string;
  mailingAddress?: IMailingAddress | null;
  stayInTouch?: string | undefined | null;
  colorFlag?: string | undefined | null;
  address: {
    country: string;
    block: string;
    unitNo: string;
    street: string;
    postal: string;
    building: string;
  };
  nationalityCode: string;
  customerId: number | undefined | null;
  age?: number;
}

interface IinitialState {
  myInfo: MyInfoProps;
  myinfoTransactionId: string;
  isMyInfoSumbitted: boolean;
  isMailingAddressConfirmed: boolean;
  rentalPostalCustomer: string;
}

export const initialState: IinitialState = {
  myInfo: {
    salutation: "",
    firstName: "",
    lastName: "",
    fullName: "",
    mobileNum: "",
    emailId: "",
    nric: "",
    dateOfBirth: "",
    nationality: "",
    residentialStatus: "",
    gender: "",
    mailingAddress: null,
    stayInTouch: null,
    colorFlag: null,
    address: {
      country: "SG",
      block: "",
      unitNo: "",
      street: "",
      postal: "",
      building: "",
    },
    nationalityCode: "",
    customerId: null,
    age: -1,
  },
  myinfoTransactionId: "",
  isMyInfoSumbitted: false,
  isMailingAddressConfirmed: false,
  rentalPostalCustomer: "",
};

const step2Slice = createSlice({
  name: "Ever_Green_Step_2",
  initialState,
  reducers: {
    updateMyInfoRecord: (state, action: PayloadAction<MyInfoProps | {}>) => {
      state.myInfo = { ...state.myInfo, ...action.payload };
    },
    updateIsMailingAddressConfirmed: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isMailingAddressConfirmed = action.payload;
    },
    updateMyInfoTransactionId: (state, action: PayloadAction<string>) => {
      state.myinfoTransactionId = action.payload;
    },
    updateRentalPostalCustomer: (state, action: PayloadAction<string>) => {
      state.rentalPostalCustomer = action.payload;
    },
    updateMailingAddressState: (
      state,
      action: PayloadAction<IMailingAddress | null>
    ) => {
      state.myInfo = {
        ...state.myInfo,
        mailingAddress: action.payload,
      };
    },
    updateIsMyInfoSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isMyInfoSumbitted = action.payload;
    },
    updateStep2ToDefault: (state,action)=>({
      ...initialState
    })
  },
});

export const {
  updateMyInfoRecord,
  updateMyInfoTransactionId,
  updateIsMailingAddressConfirmed,
  updateRentalPostalCustomer,
  updateMailingAddressState,
  updateIsMyInfoSubmitted,
  updateStep2ToDefault
} = step2Slice.actions;

export default step2Slice.reducer;
